import { NgProgressService } from './progress'

export class LoadingService {
    constructor(private _progressService: NgProgressService) {}

    private _loadCount: number = 0
    private _startTimeOut!: number
    private _isLoading: boolean = false
    public loadId: number = 0

    private setComplete(forceReset: boolean = false) {
        window.clearTimeout(this._startTimeOut)
        this._progressService.done(forceReset)
        this._isLoading = false
    }
    public isLoading(): boolean {
        return this._isLoading
    }
    public begin(): number {
        if (this._loadCount == 0) {
            window.clearTimeout(this._startTimeOut)

            this._startTimeOut = window.setTimeout(() => {
                this._isLoading = true
                this._progressService.start()
            }, 350)
        }

        this._loadCount++
        return this.loadId
    }
    public end(loadId: number): number {
        if (loadId == this.loadId) {
            this._loadCount--

            if (!(this._loadCount > 0)) {
                this.setComplete()
            }
        }
        return this.loadId
    }
    public reset(): number {
        this.loadId++
        this._loadCount = 0
        this.setComplete(true)
        return this.loadId
    }
}
